const eatEvent = event => {
  event.stopPropagation();
  event.stopImmediatePropagation();
  event.preventDefault();

  // eslint-disable-next-line no-console
  console.info('eating event', event.type);
};

export default eatEvent;